export default __webpack_public_path__ + "static/media/foto_mision.d0aa0982.png";